import { TableColumn } from "../../types";
import { NameDescriptionColumn } from "./nameDescriptionColumn";

export function NameDescriptionNoLinkColumn<TData extends { name: string; description: string; kind: string }>(
  column?: Partial<TableColumn<TData>>,
) {
  return NameDescriptionColumn(column, { shouldSkipLink: () => true });
}
